import { useCallback, useState } from 'react';

import {
  type BulkDonorScheduleAction,
  useBulkDonorScheduleStore,
} from '../../hooks/use-bulk-donor-schedule-store';
import type { FarbroRosterSourceRow } from '../utils/farbro-roster-parser';
import type { FarbroBulkDonorScheduleInput } from '../utils/schema';

type SharedAction = BulkDonorScheduleAction<FarbroBulkDonorScheduleInput>;
type FarbroUploadAction = Extract<
  SharedAction,
  { type: 'upload_from_excel' }
> & {
  sourceRows: FarbroRosterSourceRow[];
};
type FarbroAction =
  | Exclude<SharedAction, { type: 'upload_from_excel' }>
  | FarbroUploadAction;

export function useFarbroBulkDonorScheduleStore() {
  const [state, dispatch] =
    useBulkDonorScheduleStore<FarbroBulkDonorScheduleInput>();
  const [sourceRows, setSourceRows] = useState<FarbroRosterSourceRow[]>();

  const farbroDispatch = useCallback(
    (action: FarbroAction) => {
      if (action.type === 'reset') {
        setSourceRows(undefined);
      } else if (action.type === 'upload_from_excel') {
        setSourceRows(action.sourceRows);
      }

      dispatch(action);
    },
    [dispatch],
  );

  return [{ ...state, sourceRows }, farbroDispatch] as const;
}
